import classNames from 'classnames';
import { IconNameV1 } from 'common/icon/iconV1.js';
import { AccordionNew } from './accordion-new.js';
import { AccordionStyleProps } from './types.js';

export type AccordionData = { icon?: IconNameV1; text: string; title: string; key: string };

export function AccordionStyleFour<T extends { key: string }>({
  items,
  className,
  defaultToOpen,
  openIndexAsDefault,
  bodyContent,
  headerContent,
  restrictToOnlyOneChildOpen,
}: AccordionStyleProps<T>) {
  if (items && items.length) {
    return (
      <>
        <AccordionNew
          dataComponent="accordian-style-four"
          className={classNames('Accordion--style-4', className)}
          headers={items.map((item) => {
            return (
              <div key={item.key} className="u-textSemibold">
                {headerContent(item)}
              </div>
            );
          })}
          defaultToOpen={defaultToOpen}
          openIndexAsDefault={openIndexAsDefault}
          restrictToOnlyOneChildOpen={restrictToOnlyOneChildOpen}
          bodies={items.map((item) => {
            return bodyContent(item);
          })}
        />
      </>
    );
  }
  return null;
}
